import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PostDatedPresCount {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  PostDatedPresCountData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: PostDatedPresCount = {
  isLoading: false,
  error: false,
  message: null,
  PostDatedPresCountData: [],
  Items: [],
  Pagination: [],
};

const PostDatedPresCountSlice = createSlice({
  name: "postdatedprescriptioncount",
  initialState,
  reducers: {
    loadingPostDatedPresCount: (
      state: PostDatedPresCount,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setPostDatedPresCount: (
      state: any,
      action: PayloadAction<PostDatedPresCount>
    ) => {
      return action.payload;
    },
    clearData: (state: PostDatedPresCount, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingPostDatedPresCount, setPostDatedPresCount, clearData } =
  PostDatedPresCountSlice.actions;
export default PostDatedPresCountSlice.reducer;
